import { useStringFlagValue } from '@openfeature/react-sdk';

/**
 * Speaker UI on the V2 transcript follows `release-diarisation`.
 * `ui-only` and the transcript/notes variants show it. `off`, `D`, `E`,
 * and any other value do not. A session still shows speaker controls only
 * when its stored transcript has speaker segments.
 *
 * Lives in this standalone `.ts` module (not the `index.ts` barrel) so it
 * does not add a `react-refresh/only-export-components` warning. Import via
 * `@/features/flags`, which re-exports it.
 */
export const DIARISATION_UI_FLAG_KEY = 'release-diarisation';

export const DIARISATION_UI_FLAG_DEFAULT = 'off';

const DIARISATION_UI_VARIANTS = new Set([
  'ui-only',
  'english-transcript',
  'english-notes',
  'all-languages-transcript',
  'all-languages-notes',
]);

export const useIsDiarisationUiEnabled = (): boolean =>
  DIARISATION_UI_VARIANTS.has(
    useStringFlagValue(DIARISATION_UI_FLAG_KEY, DIARISATION_UI_FLAG_DEFAULT)
  );
